import { connect } from 'react-redux';
import EditModule from './EditModule';

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(EditModule);
